import React from "react";
import bgImage from "../../assets/images/get_started.jpg";
import { Button } from "../styles/Design";


const GetStarted = () => {
  return (
    <div
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "50vh",
        width: "100vw",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: "70px",
      }}
    >
      <div
        style={{
          background: "rgba(1,47,107,0.66)",
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: 'center'
        }}
      >
        <h2
          style={{
            fontSize: "32px",
            fontWeight: "700",
            color: "#fff",
          }}
        >
          Browse Our{" "}
          <span
            style={{
              color: "#F6981E",
            }}
          >
            6,00+
          </span>{" "}
          Latest Jobs
        </h2>
        <p
          style={{
            fontSize: "16px",
            fontWeight: "500",
            color: "#fff",
          }}
        >
          Get your best job in here
        </p>
        <Button type="secondary">Get Started Now</Button>
      </div>
    </div>
  );
};

export default GetStarted;
